import {Component} from "react";

export class SellToWebModalDialogHeaderButtonComponent extends Component {
    render() {
        return null;
    }
} 
